/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Icons_getPhotoLibrary$ref: FragmentReference;
declare export opaque type Icons_getPhotoLibrary$fragmentType: Icons_getPhotoLibrary$ref;
export type Icons_getPhotoLibrary = {|
  +getPhotoLibrary: ?$ReadOnlyArray<?{|
    +_id: ?string,
    +name: ?string,
    +image: ?string,
  |}>,
  +$refType: Icons_getPhotoLibrary$ref,
|};
export type Icons_getPhotoLibrary$data = Icons_getPhotoLibrary;
export type Icons_getPhotoLibrary$key = {
  +$data?: Icons_getPhotoLibrary$data,
  +$fragmentRefs: Icons_getPhotoLibrary$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Icons_getPhotoLibrary",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "rec_per_page",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "name",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "file_type",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "type",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getPhotoLibrary",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "file_type",
          "variableName": "file_type"
        },
        {
          "kind": "Variable",
          "name": "name",
          "variableName": "name"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "rec_per_page",
          "variableName": "rec_per_page"
        },
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "type"
        }
      ],
      "concreteType": "photoLibraryType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "_id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "image",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c2fc68af51231a61e7552e2504f71f66';
module.exports = node;
